import SurveyCentral from './SurveyCentral';

export default SurveyCentral;